import { jwtDecode } from "jwt-decode";
import { useAuthAppStore } from "@/store/stores/authStore";
import { CProXServiceClient } from "@/serviceClients/CProXServiceClient";
import router from "@/router";

export class AuthService {
  parseToken({ data }) {
    var access_token = data.bearerToken;

    var authInfo = {
      isAuthentication: false,
      parsedToken: null,
    };

    if (!(access_token == null || access_token === undefined)) {
      const parsedAccessToken = jwtDecode(access_token);
      const unixDateNowCode = Math.floor(Date.now() / 1000);
      if (unixDateNowCode < parsedAccessToken.exp) {
        authInfo = {
          isAuthentication: true,
          parsedToken: {
            userName: parsedAccessToken.preferred_username,
            family_name: parsedAccessToken.family_name,
            given_name: parsedAccessToken.given_name,
            expireDate: parsedAccessToken.exp,
            roles: data.roles,
            perms: data.permissions,
            email: parsedAccessToken.email,
          },
          departmentCode: data.departmentCode,
          departmentName: data.departmentName ?? data.departmentCode,
          refreshToken: data?.refreshToken,
          refreshTokenExpired: data?.refreshTokenExpiry,
        };
      } else {
        // exp olmus logine yonlenmesi gerekli.
        authInfo = {
          isAuthentication: false,
          parsedToken: null,
        };
      }
    } else {
      //token hiç yoksa
      authInfo = {
        isAuthentication: false,
        parsedToken: null,
      };
    }

    return authInfo;
  }

  parseReLoginToken({ data }) {
    console.log("parseReLoginToken------->", data);

    var access_token = data.bearerToken;

    var authInfo = {
      isAuthentication: false,
      parsedToken: null,
    };

    if (!(access_token == null || access_token === undefined)) {
      const parsedAccessToken = jwtDecode(access_token);
      const unixDateNowCode = Math.floor(Date.now() / 1000);
      if (unixDateNowCode < parsedAccessToken.exp) {
        const existingParsedToken = useAuthAppStore().getParsedToken;
        authInfo = {
          isAuthentication: true,
          parsedToken: {
            userName: parsedAccessToken.preferred_username,
            family_name: parsedAccessToken.family_name,
            given_name: parsedAccessToken.given_name,
            expireDate: parsedAccessToken.exp,
            roles: parsedAccessToken.roles ?? existingParsedToken?.roles,
            perms: parsedAccessToken.perms ?? existingParsedToken?.perms,
            email: parsedAccessToken.email,
          },
          departmentCode: useAuthAppStore().getUserAuthState.departmentCode,
          departmentName: useAuthAppStore().getUserAuthState.departmentName,
          refreshToken: useAuthAppStore().getUserAuthState.refreshToken,
          refreshTokenExpired: useAuthAppStore().getUserAuthState.refreshTokenExpired,
        };
      } else {
        // exp olmus logine yonlenmesi gerekli.
        // authInfo = {
        //   isAuthentication: false,
        //   parsedToken: null,
        // };
      }
    } else {
      //token hiç yoksa
      authInfo = {
        isAuthentication: false,
        parsedToken: null,
      };
    }

    return authInfo;
  }

  checkExpired(parsedAccessToken) {
    const currentUnixTime = Math.floor(Date.now() / 1000);
    return (
      !parsedAccessToken?.expireDate ||
      currentUnixTime > parsedAccessToken.expireDate
    );
  }

  async getFindPermissionsByUserNameAndType({
    authenticationServiceClient,
    params,
  }) {
    var response = await authenticationServiceClient.get({
      route: "/permission/find-permissions-by-user-name-and-type",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  checkExpireBeforeRequest = async () => {
    const isAccessTokenExpired = useAuthAppStore().checkExpiredNow();
    console.log("isAccessTokenExpired", isAccessTokenExpired);

    let user = useAuthAppStore().getUserAuthState;

    let authServiceClient = new CProXServiceClient({
      baseUri:
        window.appsettings.ProjectConfig.ConnectedProject
          .CProXApiServiceClientUrl,
    });

    // The call to this.parseDate() will now work correctly
    const refreshTokenExpiry = this.parseDate(user?.refreshTokenExpired);

    const now = new Date();

    const isRefreshTokenExpired = refreshTokenExpiry <= now;

    if (isAccessTokenExpired) {
      if (!isRefreshTokenExpired) {
        const response = await authServiceClient.get({
          route: "/authentication/access-token",
          params: { RefreshToken: user.refreshToken },
        });
        if (response?.data?.accessToken) {
          useAuthAppStore().setReLogin({
            data: { bearerToken: response.data.accessToken },
          });
        }
      }
    }
  };

  parseDate(msDateString) {
    if (!msDateString) return null;

    // Eğer sayı gelirse (timestamp gibi)
    if (!isNaN(msDateString)) {
      if (msDateString.toString().length === 10) {
        return new Date(parseInt(msDateString, 10) * 1000);
      }
      return new Date(parseInt(msDateString, 10));
    }

    // ISO format
    if (typeof msDateString === "string" && msDateString.includes("T")) {
      return new Date(msDateString);
    }

    // .NET formatı (/Date(1234567890)/ veya /Date(1234567890))
    if (typeof msDateString === "string") {
      const match = /\/Date\((\d+)\)\/?/.exec(msDateString);
      if (match) {
        return new Date(parseInt(match[1], 10));
      }
    }

    return null;
  }
}
